
import { mapState } from 'vuex'
import footerLinks from '~/components/common/footerLinks.vue'
import mobileBottom from '~/components/common/mobileBottom.vue'
// import nationList from '~/static/json/countryList.json'
import riskWarning from '~/components/common/riskWarning.vue'
export default {
  components: {
    'mobile-bottom': mobileBottom,
    'risk-warning': riskWarning,
    'footer-links': footerLinks
  },
  data() {
    let _cookie = ''
    if (this.$store.state?.contentcookie) {
      _cookie = `?contentcookie=${encodeURI(this.$store.state.contentcookie)}`
    }
    return {
      // linkDom: '', // 外链dom
      isHover: false, // 鼠标是否移入选择国家
      mySearch: '', // 用户输入的国家
      // 底部
      countryList: this.$store.state.footCountry, // 弹框国家列表
      showMNation: true, // 是否展示国家列表弹框（移动端）
      searchcounryList: [], // 搜索到的国家
      traderheight: true,
      traderactive: 1,
      CookieForJump: _cookie,
      setcountry: {
        country: '',
        flag: ''
      }
    }
  },
  computed: {
    ...mapState({
      linkDom: 'linkDom',
      contentcookie: 'contentcookie'
    }),
    // 本项目logo
    fxLogo() {
      const selectedLang = this.currLangCode()
      if (selectedLang == 'zh-cn') return 'https://resources1.interface003.com/web20/img/home/logo-cn.svg'
      else if (['zh-tw', 'zh-hk', 'zh'].includes(selectedLang)) return 'https://resources1.interface003.com/web20/img/home/logo-tw.svg'
      else return 'https://resources1.interface003.com/web20/img/home/logo-en.svg'
    },
    // 用户IP定位的国家信息
    myCountryInfo() {
      const {
        flag = '',
        name = '',
        countryCode: code = '',
        twoCharCode = ''
      } = this.getMyCountry({
        twoCharCode: this.userCountry()?.toUpperCase()
      }) || {}
      return { flag, name, code, twoCharCode }
    },
    // 用户选择的国家是否和IP定位的国家一致
    isMyNation() {
      const { CountryCode = 'us', myCountry = 'us' } = this.$store.state
      return CountryCode != myCountry
    },
    getLinkHtml() {
      const curlan = this.currLangCode()
      const newhost = this.$store.state.newhost
      const linkList = [
        {
          name: '关于我们',
          key: '20653',
          url: `${this.getwwwDomain(this.$store.state)}/${curlan}/about.html`,
          show: true
        },
        {
          name: '联系我们',
          key: '21918',
          url: `${this.getwwwDomain(this.$store.state)}/${curlan}/contract.html`,
          show: true
        },
        { name: '风险提示', key: '20654', url: 'javascript:;', show: true },
        {
          name: '使用条款',
          key: '20655',
          url: `${this.getwwwDomain(this.$store.state)}/${curlan}/terms.html?type=1`,
          show: true
        },
        {
          name: '隐私声明',
          key: '20656',
          url: `${this.getwwwDomain(this.$store.state)}/${curlan}/terms.html?type=3`,
          show: true
        },
        {
          name: '搜索调用',
          key: '20657',
          url: `${this.getwwwDomain(this.$store.state)}/${curlan}/tradersearch_open.html`,
          show: true
        },
        {
          name: '企业版(天眼号)',
          key: '20658',
          url: `https://www.wikifxmanager.com/${curlan}/login${this.CookieForJump}`,
          show: true
        },
        {
          name: '官方验证',
          key: '20659',
          url: `//v.${newhost}.${this.$store.state.suffix}/${curlan}`,
          show: true
        },
        {
          name: 'WikiEXPO',
          key: '20660',
          url: `//www.wikiexpo.com/${['zh-cn', 'zh', 'en'].includes(curlan) ? curlan : 'en'}/`,
          show: true
        },
        {
          name: '天眼研究院',
          key: '20661',
          url: `//www.wikiresearch.com/${curlan}/`,
          show: true
        },
        {
          name: 'VPS使用帮助',
          key: '24790',
          url: `https://vps.${newhost}.${this.$store.state.suffix}/${curlan}/help/help-list.html`,
          show: this.$store.state.riskcontrol['12009'] != '0'
        },
        {
          name: '商务合作',
          key: '20779',
          url: `${this.getwwwDomain(this.$store.state)}/${curlan}/contract.html`,
          show: true
        },
        {
          name: '地区划分',
          key: '41736',
          url: `${this.getwwwDomain(this.$store.state)}/${curlan}/country.html`,
          show: true
        }
      ]
      let str = ''
      linkList?.forEach((item, index) => {
        if (item.show) {
          if (index == 2) {
            str += `<a href="${item.url}" onclick="test()" class="single-link">${this.$t(item.key)}</a><i class="segment">|</i>`
          } else {
            str += `<a href="${item.url}" target="_blank" class="single-link">${this.$t(item.key)}</a><i class="segment">|</i>`
          }
        }
      })
      return str
    }
  },
  watch: {
    '$store.state.contentcookie'(newVal) {
      if (this.$store.state?.contentcookie) {
        this.CookieForJump = `?contentcookie=${encodeURI(this.$store.state.contentcookie)}`
      } else {
        this.CookieForJump = ''
      }
      const str = this.getLinkHtml
      this.$store.commit('setlinkDom', str)
    }
  },
  created() {
    //
    if (process.client) return
    // 处理外链dom
    const str = this.getLinkHtml
    this.$store.commit('setlinkDom', str)
  },
  mounted() {
    this.gettraderheight()
    this.CheckHadMediaReport()
    window.test = (event) => {
      this.$refs.riskWarning.dialogVisible = true
    }
    document.addEventListener(
      'click',
      () => {
        this.showMNation = true
      },
      { passive: true }
    )
  },
  methods: {
    // 更换国家
    countryFn(obj = {}, type = 1) {
      const { host: hostS = '' } = this.$store.state
      const abbr = type == 1 ? obj?.abbr : obj?.twoCharCode.toLowerCase()
      console.log('abbr: ', abbr)
      this.$store.commit('setCountryCode', { country: abbr, hostS })
      this.setcountry = {
        country: obj?.name,
        flag: obj?.flag
      }
      const arr = [
        {
          lang: 'ja',
          country: 'jp'
        },
        {
          lang: 'vi',
          country: 'vn'
        },
        {
          lang: 'th',
          country: 'th'
        },
        {
          lang: 'id',
          country: 'id'
        },
        {
          lang: 'zh',
          country: 'hk'
        },
        {
          lang: 'zh',
          country: 'tw'
        },
        {
          lang: 'es',
          country: 'es'
        },
        {
          lang: 'en',
          country: 'au'
        },
        {
          lang: 'de',
          country: 'de'
        },
        {
          lang: 'en',
          country: 'uk'
        },
        {
          lang: 'en',
          country: 'us'
        },
        {
          lang: 'zh-cn',
          country: 'cn'
        },
        {
          lang: 'ar',
          country: 'ae'
        },
        {
          lang: 'ru',
          country: 'ru'
        },
        {
          lang: 'fil',
          country: 'ph'
        },
        {
          lang: 'hi',
          country: 'in'
        },
        {
          lang: 'fr',
          country: 'fr'
        },
        {
          lang: 'tr',
          country: 'tr'
        },
        {
          lang: 'pt',
          country: 'pt'
        },
        {
          lang: 'ko',
          country: 'kr'
        }
      ]
      const tabcontry = arr.filter((item) => item.country == abbr)
      if (tabcontry && tabcontry[0] && tabcontry[0].lang) {
        const url = window.location.pathname.split('/').slice(2).join('/')
        const serach = window.location.search ? `${window.location.search}` : ''
        window.location.href = `/${tabcontry[0].lang}/${url}${serach}`
        return
      }
      this.$nextTick(() => {
        location.reload(true)
      }) // 页面刷新
    },
    searchCountry() {
      // 搜索国家
      if (!this.mySearch) return
      this.$api.home.countrysearch({ content: this.mySearch }).then((res) => {
        // res.forEach((item) => {
        //   if (item.code == '344') {
        //     item.name = this.$t('28304')
        //   }
        //   if (item.code == '156') {
        //     item.name = this.$t('22271')
        //     item.flag = 'https://img.souhei.com.cn/flags/344.png_wiki-template-global'
        //   }
        // })
        this.searchcounryList = [...res]
      })
    },
    leaveCountry() {
      this.mySearch = ''
      this.searchcounryList = []
      this.isHover = false
    },
    gettraderheight() {
      if (!document.getElementById('traderList')) return
      const height = document.getElementById('traderList').offsetHeight
      if (height <= 68) this.traderheight = false
    },
    opentrader() {
      this.traderheight = false
      this.$nextTick(() => {
        document.getElementsByTagName('html')[0].scrollTop = document.getElementsByTagName('body')[0].scrollHeight
      })
    },
    tabtraderfn(val) {
      this.traderactive = val
      // this.traderheight = true
      // this.gettraderheight()
      this.$nextTick(() => {
        if (this.traderactive == 1) {
          if (!document.getElementById('traderList')) return
          const height = document.getElementById('traderList').offsetHeight
          console.log(height, 777)
          if (height <= 68) {
            this.traderheight = false
          } else {
            this.traderheight = true
          }
        } else {
          if (!document.getElementById('traderList-q')) return
          const height = document.getElementById('traderList-q').offsetHeight
          console.log(height, 777)
          if (height <= 68) {
            this.traderheight = false
          } else {
            this.traderheight = true
          }
        }
      })
    },
    CheckHadMediaReport() {
      this.$api.common.CV3({}, { Routes: 'primarymodule$webmediacoverageexist' }).then((result) => {
        if (result?.primarymodule?.webmediacoverageexist?.data) {
          let str = this.linkDom
          str += `<a href="${this.getwwwDomain(this.$store.state)}/${this.currLangCode()}/about.html?type=3" target="_blank" class="single-link">${this.$t('41901')}</a>`
          this.$store.commit('setlinkDom', str)
        }
      })
    }
  }
}
